import React from 'react';
import AddProduct from '../components/Addproduct';
import ProductList from '../components/productList';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header2 from '../components/Header2';
toast.configure()
const Dash = () => {
    const onSubmit =async () =>{
        toast.success("Image successfully Uploaded");
    };
    return (
        <div>
            <Header2 />
            <div className="container">
            <div>
        <div className='custom-file mb-4'>
        <input type='file' className='custom-file-input' id='customFile'/>
        <label className='custom-file-label' htmlFor='customFile'>Shop image.jpg</label>

    </div>
    <button onClick={onSubmit} placeholder="Upload" style={{height:"30px"}} className='btn btn-primary btn-block mt-6'><h6>Upload</h6></button>
    </div>
            <AddProduct />
            <ProductList/>
            </div>
            </div>
    );
};
export default Dash;